function attachSwuPublishAction () {
  swuConfirmClickAction('swu-publish')
}

function attachSwuResendAction () {
  swuConfirmClickAction('swu-resend')
}

function attachSwuScheduleAction () {
  const openModal = function () {
    // Use of jQuery instead of vanilla Javascript is required to call Bootstrap modal
    $('#schedule_dialog').modal('show')
  }

  swuModalClickAction('swu-schedule', openModal)
}

function attachSwuTestAction () {
  const openModal = function () {
    // Use of jQuery instead of vanilla Javascript is required to call Bootstrap modal
    $('#send_test_dialog').modal('show')
  }

  swuModalClickAction('swu-test', openModal)
}

function swuConfirmClickAction (elementId) {
  const element = document.getElementById(elementId)

  if (element) {
    element.onclick = function (evt) {
      evt.preventDefault()

      if (overSwuContentLimit()) {
        sendSwuContentLimitMessage()
        evt.stopPropagation()
      } else if (overSwuAttachmentLimit()) {
        sendSwuAttachmentLimitMessage()
        evt.stopPropagation()
      } else {
        // Everything is fine. Call next event
      }
    }
  }
}

function swuModalClickAction (elementId, elseAction) {
  const actionElement = document.getElementById(elementId)

  if (actionElement) {
    actionElement.addEventListener('click', function (evt) {
      evt.preventDefault()

      if (overSwuContentLimit()) {
        sendSwuContentLimitMessage()
      } else if (overSwuAttachmentLimit()) {
        sendSwuAttachmentLimitMessage()
      } else {
        elseAction()
      }
    }, false)
  }
}

function overSwuContentLimit () {
  const maxByteSize = swuContentByteLimit()
  const contentElementDataSize = contentByteLength()

  return contentElementDataSize > maxByteSize
}

function overSwuAttachmentLimit () {
  const maxByteSize = swuAttachmentByteLimit()
  const attachmentDataSize = bulletinAttachmentByteLength()

  return attachmentDataSize > maxByteSize
}

function sendSwuContentLimitMessage () {
  const maxByteSize = swuContentByteLimit()
  const contentElementDataSize = contentByteLength()

  sendSwuFlashErrorMessage(`Can not send. Content length is too long. Limit is ${convertBytes(maxByteSize)}. Current size is ${convertBytes(contentElementDataSize, 1)}`)
}

function sendSwuAttachmentLimitMessage () {
  const maxByteSize = swuAttachmentByteLimit()

  sendSwuFlashErrorMessage(`Can not send. Total attachment size is too large. Limit is ${convertBytes(maxByteSize, 1)}.`)
}

function contentByteLength () {
  const bulletinElement = document.getElementById('bulletin_content')
  const newsletterElement = document.getElementById('newsletter-html-container')

  if (newsletterElement) {
    return newsletterElement.innerHTML.length
  } else if (bulletinElement) {
    return bulletinElement.innerHTML.length
  } else {
    return 0
  }
}

function bulletinAttachmentByteLength () {
  let attachmentFilesizeTotal = 0

  const attachedFiles = document.querySelectorAll('ul.images a, ul.files a');

  [].forEach.call(attachedFiles, (attached) => {
    attachmentFilesizeTotal += parseInt(attached.getAttribute('data-filesize'))
  })

  return attachmentFilesizeTotal
}

function swuContentByteLimit () {
  // 128Kb SWU limit - 3Kb buffer = 125Kb
  return (128 - 3) * 1024
}

function swuAttachmentByteLimit () {
  // 7Mb SWU limit - 0.5Mb buffer = 6.5Mb
  return (7 - 0.5) * (1024 * 1024)
}

function sendSwuFlashErrorMessage (message) {
  window.flash('error', 'Alert', message)
}

function convertBytes (bytes, decimalPlaces = 0) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']

  if (bytes === 0) return '0 Bytes'

  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)

  if (i === 0) return `${bytes} ${sizes[i]})`

  return `${(bytes / (1024 ** i)).toFixed(decimalPlaces)} ${sizes[i]}`
}

document.addEventListener('DOMContentLoaded', function () {
  attachSwuPublishAction()
  attachSwuResendAction()
  attachSwuScheduleAction()
  attachSwuTestAction()
})
